class AnimationScroll extends HTMLElement {
    connectedCallback() {
        this.section = this.querySelector('[data-heritge-section]');
        if (!this.section) {
            return;
        }

        this.textElements = this.section.querySelectorAll('.fade-out-text');

        window.addEventListener('scroll', this.handleScroll.bind(this));
    }

    handleScroll () {
        const sectionRect = this.section.getBoundingClientRect();
        const sectionHeight = this.section.offsetHeight;

        let progress = Math.min(1, Math.max(0, (sectionRect.bottom - sectionHeight) / sectionHeight));

        this.textElements.forEach(element => {
            element.style.opacity = 1 - progress - 0.2;
        });
    };

    disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
    }
}

customElements.define('animation-scroll', AnimationScroll);